module.exports = __webpack_public_path__ + "static/starCharge/img/shareImgToFriend.d7963eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/starcharge/assets/img/shareImgToFriend.png
// module id = RDnY
// module chunks = 81